module.exports = __webpack_public_path__ + "img/pauli-z-root-17.918da5da.svg";